import React, { Component } from "react";
import { connect } from "react-redux";
import { setErrors, clearErrors } from "../../../actions/error.js";
import { updateUser } from "../../../actions/user.js";

import Button from "../../../common/button/Button";
import Row from "../../../common/grid/Row";
import Col from "../../../common/grid/Col";
import Input from "../../../common/input/Input";
import Section from "../../../common/section/Section";
import EditDropdown from "./EditDropdown";
import Dialog from "./Dialog";
import UploadButton from "../../../common/button/UploadButton.js";

import "./Profile.css";

class ProfileInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmed: false,
      confirmation: false,
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      password_confirmation: "",
      phone: "",
      contract_url: "",
      contract_file: null,
      agreement_url: '',
      agreement_file: null,
      job_description_url: '',
      job_description_file: null
    };

    this.onFileUpload = this.onFileUpload.bind(this);
  }

  confirm = (confirmation, confirmed) => {
    this.setState({ confirmation, confirmed });
  };

  validate = () => {
    let errors = {};

    if (this.state.password) {
      if (this.state.password.length < 6) {
        errors["password"] = ["Password must be at least 6 characters long!"];
      }

      if (this.state.password !== this.state.password_confirmation) {
        errors["password_confirmation"] = [
          "Password Confirmation must match the password!"
        ];
      }
    }

    this.props.addErrors(errors);
    return Object.keys(errors).length === 0;
  };

  handleInputChange = (text, name) => {
    this.setState({ [name]: text });
  };

  onFileUpload(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    let name = e.target.name;

    reader.onloadend = () => {
      this.setState({
        [name]: file,
        [name + '_data']: reader.result
      });
    };

    reader.readAsDataURL(file);
  }

  handleSaveClick = () => {
    if (this.validate()) {
      const profile = {
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
        phone: this.state.phone,
        contract_file: this.state.contract_file,
        agreement_file: this.state.agreement_file,
        job_description_file: this.state.job_description_file
      };

      this.setState({
        confirmed: false,
        confirmation: false,
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        contract_file: null,
        agreement_file: null,
        job_description_file: null
      });

      this.props.updateUser(this.props.user.id, profile);
      this.props.emptyErrors();
    }
  };

  inputsUpdated = () => {
    // TODO: improve validation
    const {
      first_name,
      last_name,
      email,
      password,
      password_confirmation,
      phone,
      contract_file,
      agreement_file,
      job_description_file
    } = this.state;
    return (
      first_name ||
      last_name ||
      email ||
      password ||
      password_confirmation ||
      phone ||
      contract_file ||
      agreement_file ||
      job_description_file
    );
  };

  componentWillUpdate(nextProps, nextState) {
    const { confirmation } = this.state;
    if (nextState.confirmation !== confirmation) {
      document.body.classList.toggle("focused-out", nextState.confirmation);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.user.passwordVerified) {
      this.setState({ confirmation: false, confirmed: true });
    }
  }

  render() {
    const { confirmation, confirmed, password } = this.state;
    if (!this.props.user) {
      return <div>Loading...</div>;
    }
    return (
      <Section
        className="profile-info white"
        heading="Profile information / edit profile"
      >
        {confirmation && <Dialog password={password} confirm={this.confirm} />}
        <EditDropdown confirm={this.confirm} confirmed={confirmed}>
          <Row>
            <Col _bottom-4>
              <div className="key">first name</div>
              <div className="value">{this.props.user.first_name}</div>
            </Col>
            <Col _bottom-4>
              <div className="key">last name</div>
              <div className="value">{this.props.user.last_name}</div>
            </Col>
          </Row>
          <Row _gap-8>
            <Input
              type="text"
              name="first_name"
              ph="first name"
              onChange={this.handleInputChange}
            />
            <Input
              type="text"
              name="last_name"
              ph="last name"
              onChange={this.handleInputChange}
            />
          </Row>
        </EditDropdown>
        <EditDropdown confirm={this.confirm} confirmed={confirmed}>
          <Col _bottom-4>
            <div className="key">email</div>
            <div className="value">{this.props.user.email}</div>
          </Col>
          <Input
            type="email"
            name="email"
            ph="email"
            onChange={this.handleInputChange}
          />
        </EditDropdown>
        <EditDropdown confirm={this.confirm} confirmed={confirmed}>
          <Col _bottom-4>
            <div className="key">phone</div>
            <div className="value">{this.props.user.phone}</div>
          </Col>
          <Input
            type="tel"
            name="phone"
            ph="phone"
            onChange={this.handleInputChange}
          />
        </EditDropdown>
        <EditDropdown confirm={this.confirm} confirmed={confirmed}>
          <Col _bottom-4>
            <div className="key">password</div>
            <div className="value">you have a protected password</div>
          </Col>
          <Row _gap-8>
            <Input
              type="password"
              name="password"
              ph="password"
              onChange={this.handleInputChange}
            />
            <Input
              type="password"
              name="password_confirmation"
              ph="repeat password"
              onChange={this.handleInputChange}
            />
          </Row>
        </EditDropdown>
        <EditDropdown confirm={this.confirm} confirmed={confirmed}>
          <Col _bottom-4>
            <div className="key">Contract</div>
            {this.props.user.contract_url && <div className="value"><a href={this.props.user.contract_url}>Download current contract</a></div>}
            {!this.props.user.contract_url && <div className="value">Contract has not been uploaded</div>}
          </Col>
          <Row _gap-8>
            <UploadButton
              className="btn-blue btn-square add-file-btn"
              onChange={this.onFileUpload}
              accept='*'
              name='contract_file'>
              {(this.props.user.contract_url || this.state.contract_file) ? 'Change File' : 'Add File'}
            </UploadButton>
          </Row>
        </EditDropdown>
        <EditDropdown confirm={this.confirm} confirmed={confirmed}>
          <Col _bottom-4>
            <div className="key">Agreement</div>
            {this.props.user.agreement_url && <div className="value"><a href={this.props.user.agreement_url}>Download current agreement</a></div>}
            {!this.props.user.agreement_url && <div className="value">Agreement has not been uploaded</div>}
          </Col>
          <Row _gap-8>
            <UploadButton
              className="btn-blue btn-square add-file-btn"
              onChange={this.onFileUpload}
              accept='*'
              name='agreement_file'>
              {(this.props.user.agreement_url || this.state.agreement_file) ? 'Change File' : 'Add File'}
            </UploadButton>
          </Row>
        </EditDropdown>
        <EditDropdown confirm={this.confirm} confirmed={confirmed}>
          <Col _bottom-4>
            <div className="key">Job Description</div>
            {this.props.user.job_description_url && <div className="value"><a href={this.props.user.job_description_url}>Download current job description</a></div>}
            {!this.props.user.job_description_url && <div className="value">Job description has not been uploaded</div>}
          </Col>
          <Row _gap-8>
            <UploadButton
              className="btn-blue btn-square add-file-btn"
              onChange={this.onFileUpload}
              accept='*'
              name='job_description_file'>
              {(this.props.user.job_description_url || this.state.job_description_file) ? 'Change File' : 'Add File'}
            </UploadButton>
          </Row>
        </EditDropdown>
        <Col _bottom-4>
          <div className="key">Role(s)</div>
          <div className="value">
            {this.props.user.roles.map(
              (r, i) =>
                i !== this.props.user.roles.length - 1
                  ? r.display_name + ", "
                  : r.display_name
            )}
          </div>
        </Col>
        {this.inputsUpdated() && (
          <Col>
            <Row _align-center>
              <Button
                className="btn-blue btn-square"
                onClick={this.handleSaveClick}
              >
                Save Changes
              </Button>
            </Row>
          </Col>
        )}
      </Section>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.auth.currentUser
  };
};

const mapDispatchToProps = {
  addErrors: errors => dispatch => dispatch(setErrors(errors)),
  emptyErrors: () => dispatch => dispatch(clearErrors()),
  updateUser
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileInfo);



// WEBPACK FOOTER //
// ./src/components/main/profile/ProfileInfo.js